import React, { CSSProperties } from 'react';
import { Box } from '@mui/material';
import { ArrowRight001Svg } from '../../../../assets/images/svgs';
import { InfoCard, InfoCardProps } from '..';

export type InfoCardGroupProps = {
  cards: InfoCardProps[];
  separator?: React.ReactNode;
  style?: CSSProperties;
};

export const InfoCardGroup = ({
  cards,
  separator,
  style = {},
}: InfoCardGroupProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: {
          xs: 'column',
          sm: 'row',
        },
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#E3F7C9',
        borderRadius: 1,
        ...style,
      }}
    >
      {cards.map(({ style: infoCardStyle, ...rest }, index) => (
        <React.Fragment key={`group-card-info-${index}`}>
          <InfoCard
            {...rest}
            style={{
              ...infoCardStyle,
              width: 'fit-content',
            }}
          />
          {index < cards.length - 1 && (
            <Box
              sx={{
                transform: {
                  xs: 'rotate(90deg)',
                  sm: 'none',
                },
              }}
            >
              {separator ? (
                separator
              ) : (
                <Box
                  sx={{
                    paddingX: 1,
                  }}
                >
                  <ArrowRight001Svg />
                </Box>
              )}
            </Box>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};
